import { createApi } from '@/api/modules/utils'

const strategyApi = createApi('/auto_creation_strategy')
const taskApi = createApi('/auto_creation_task')

// 创作策略
export const autoCreationStrategyApi = {
  list: strategyApi('list', 'get'),
  insert: strategyApi('insert', 'post'),
  update: strategyApi('update', 'post'),
  delete: strategyApi('delete', 'get')
}

// 自动创作任务
export const autoCreationTaskApi = {
  config: taskApi('config', 'get'),
  list: taskApi('list', 'get'),
  insert: taskApi('insert', 'post'),
  update: taskApi('update', 'post'),
  delete: taskApi('delete', 'get'),
  toggleDaily: taskApi('toggle_daily', 'post'),
  execute: taskApi('execute', 'get'),
  records: taskApi('records', 'get')
}
